/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LessThanOrEqualVersion: core.serialization.ObjectSchema<
    serializers.LessThanOrEqualVersion.Raw,
    Truvity.LessThanOrEqualVersion
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace LessThanOrEqualVersion {
    export interface Raw {
        value: number;
    }
}
